document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-help-qa").forEach(function (question) {
      question.addEventListener("click", function () {
        const answer = this.nextElementSibling; // 次の兄弟要素（.p-help__area-a）
        
        // クリックされた要素に is-active クラスをトグル
        this.classList.toggle("is-active");
        
        // .p-help__area-a の表示・非表示を切り替え
        if (answer) {
          if (answer.style.display === "block") {
            answer.style.display = "none";
          } else {
            answer.style.display = "block";
          }
        }
      });
    });
  });
  